import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useCreateUserPermissionsMutation } from 'queries/admin/userPermissions'

type CreateUserPermissionsFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useCreateUserPermissionsMutation>['mutate']
    reset: ReturnType<typeof useCreateUserPermissionsMutation>['reset']
  }
}

const [Context, useCreateUserPermissionsFlowContextValue] =
  createContext<CreateUserPermissionsFlowContextState>({
    name: 'CreateUserPermissionsFlowContext',
  })

export const CreateUserPermissionsFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const { mutate, reset, isPending, isError, error } =
    useCreateUserPermissionsMutation()

  const value: CreateUserPermissionsFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useCreateUserPermissionsFlowContextValue }
